import { ArrowRight } from 'lucide-react';

import { RestaurantUnitConversionDTO } from '../../../../types/restaurant/RestaurantUnitConversionTypes';
import RestaurantTable, {
  RestaurantTableColumn,
} from '../../shared/RestaurantTable';
import RestaurantTableActions from '../../shared/RestaurantTableActions';

interface Props {
  conversions: RestaurantUnitConversionDTO[];
  onEdit: (conversion: RestaurantUnitConversionDTO) => void;
  onDeactivate: (conversion: RestaurantUnitConversionDTO) => void;
}

const UnitConversionTable = ({ conversions, onEdit, onDeactivate }: Props) => {
  const columns: RestaurantTableColumn<RestaurantUnitConversionDTO>[] = [
    {
      key: 'conversion',
      header: 'Conversión',
      cell: (item) => (
        <span className="inline-flex items-center gap-2 font-medium text-black dark:text-white">
          {item.fromUnitName}
          <ArrowRight className="h-4 w-4 text-bodydark2" />
          {item.toUnitName}
        </span>
      ),
    },
    {
      key: 'factor',
      header: 'Equivalencia',
      className: 'whitespace-nowrap text-sm text-bodydark2',
      cell: (item) => (
        <span>
          1 {item.fromUnitCode || item.fromUnitName} ={' '}
          <span className="font-semibold text-black dark:text-white">
            {item.factor}
          </span>{' '}
          {item.toUnitCode || item.toUnitName}
        </span>
      ),
    },
    {
      key: 'scope',
      header: 'Ámbito',
      cell: (item) => (
        <div className="flex flex-wrap items-center gap-1.5">
          <span className="rounded-full bg-primary/10 px-2.5 py-1 text-xs font-medium text-primary">
            {item.global ? 'Global' : 'Materia prima'}
          </span>
          {!item.global && item.rawMaterialName && (
            <span className="rounded-full bg-gray-2 px-2.5 py-1 text-xs font-medium text-body dark:bg-meta-4 dark:text-bodydark">
              {item.rawMaterialName}
            </span>
          )}
        </div>
      ),
    },
    {
      key: 'status',
      header: 'Estado',
      cell: (item) => (
        <span
          className={`rounded-full border px-2.5 py-1 text-xs font-semibold ${
            item.active
              ? 'border-success/20 bg-success/10 text-success'
              : 'border-danger/20 bg-danger/10 text-danger'
          }`}
        >
          {item.active ? 'Activa' : 'Inactiva'}
        </span>
      ),
    },
    {
      key: 'actions',
      header: 'Acciones',
      className: 'text-right',
      headClassName: 'text-right',
      cell: (item) => (
        <RestaurantTableActions
          onEdit={() => onEdit(item)}
          onToggle={item.active ? () => onDeactivate(item) : undefined}
          active={item.active}
          toggleLabel={{ on: 'Desactivar', off: 'Reactivar' }}
        />
      ),
    },
  ];

  return (
    <RestaurantTable
      columns={columns}
      rows={conversions}
      rowKey={(item) => item.id}
      rowClassName={(item) => (item.active ? '' : 'opacity-65')}
      minWidth="min-w-[900px]"
    />
  );
};

export default UnitConversionTable;
